import { useState, useEffect, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import CurrencyInput from 'react-currency-input-field';
import DataTable from 'react-data-table-component';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import { editarBreadcrumb } from '../../../actions/breadcrumb';
import { setAlert } from '../../../actions/alert';
import { buscarClientesPacientes } from '../../../actions/clientes';
import { filtrarMetodosConfiguracion } from '../../../actions/configuracion';
import { buscarProductos, buscarServicios, buscarComandas, buscarMedicos, buscarMedicosExternos, buscarPaquetesPunto, crearVenta } from '../../../actions/punto';
import { limpiarVenta } from '../../../actions/ventas';

import { formatNumber, printTicket } from '../../../utils/generalFunctions';

import { CustomValueContainer } from '../../../components/react_select/ReactSelect';

const Punto = () => {

    let rutasBread = [
        {
            activo: true,
            nombre: 'Nueva venta',
            path: '/ingresos/punto'
        }
    ];

    const dispatch = useDispatch();

    const { listado_coincidencias: listado_clientes } = useSelector(state => state.clientes);
    const { listado: listado_metodos } = useSelector(state => state.configuracion.metodos);
    const { listado_productos, listado_servicios, listado_comandas, listado_medicos, listado_medicos_externos, listado_paquetes } = useSelector(state => state.punto);
    const { detalles } = useSelector(state => state.ventas);

    const [ventaData, setVentaData] = useState({
        id_cliente: null,
        status: 0,
        total: 0,
        total_productos: 0,
        total_servicios: 0,
        busqueda_cliente: null,
        busqueda_producto: null,
        busqueda_servicio: null,
        busqueda_paquete: null,
        productos: [],
        servicios: [],
        comandas: [],
        medicos: [],
        medicos_externos: [],
        observaciones: null
    });

    const [ventaRealizadaData, setVentaRealizadaData] = useState({
        id: null,
        folio: null,
        cliente: null,
        fecha: null,
        status: 0,
        total: 0,
        metodos: [],
        productos: [],
        servicios: [],
        medicos: [],
        medicos_externos: []
    });

    const [statusProcesar, setStatusProcesar] = useState(false);

    const [unidadesData, setUnidadesData] = useState([]);
    const [pacientesData, setPacientesData] = useState([]);
    const [pacientesProductosData, setPacientesProductosData] = useState([]);

    const [buscadorClientes, setBuscadorClientes] = useState(false);
    const [buscadorProductos, setBuscadorProductos] = useState(false);
    const [buscadorServicios, setBuscadorServicios] = useState(false);

    const [clienteData, setClienteData] = useState(null);
    const [clientesFilter, setClientesFilter] = useState([]);
    
    const [metodosFilter, setMetodosFilter] = useState([]);

    const [modalMetodos, setModalMetodos] = useState(false);
    const [metodosPago, setMetodosPago] = useState([
        { id_metodo: null, tipo: 1, total: 0 }
    ]);

    const tiposMetodoFilter = [
        { value: 1, label: 'Productos' },
        { value: 2, label: 'Servicios' }
    ];

    const [seccionVenta, setSeccionVenta] = useState(0);
    const [tipoVenta, setTipoVenta] = useState(0);

    const [productoData, setProductoData] = useState(null);
    const [productosFilter, setProductosFilter] = useState([]);

    const [servicioData, setServicioData] = useState(null);
    const [serviciosFilter, setServiciosFilter] = useState([]);

    const [buscadorPaquetes, setBuscadorPaquetes] = useState(false);

    const [paqueteData, setPaqueteData] = useState(null);
    const [paquetesFilter, setPaquetesFilter] = useState([]);

    const [comandaData, setComandaData] = useState(null);
    const [comandasFilter, setComandasFilter] = useState([]);

    const [medicoData, setMedicoData] = useState(null);
    const [medicosFilter, setMedicosFilter] = useState([]);

    const [medicoExternoData, setMedicoExternoData] = useState(null);
    const [medicosExternosFilter, setMedicosExternosFilter] = useState([]);

    const totalMetodos = metodosPago.reduce(
        (sum, m) => m.id_metodo ? sum + Number(m.total || 0) : sum,
        0
    );

    const restanteMetodos = Number(ventaData.total || 0) - totalMetodos;

    const totalProductosMetodos = metodosPago.reduce(
        (sum, m) => m.id_metodo && m.tipo == 1 ? sum + Number(m.total || 0) : sum, 0
    );
    const totalServiciosMetodos = metodosPago.reduce(
        (sum, m) => m.id_metodo && m.tipo == 2 ? sum + Number(m.total || 0) : sum, 0
    );
    const totalGeneralMetodos = metodosPago.reduce(
        (sum, m) => m.id_metodo && m.tipo == 0 ? sum + Number(m.total || 0) : sum, 0
    );

    const columnsProductos = [
        {
            name: 'Producto',
            cell: row => row.nombre,
            grow: 4,
            wrap: true
        },
        {
            name: 'Paciente',
            grow: 1.5,
            cell: (row, index) => {
                return(
                    <div className="input-group h-100 py-2">
                        <Select
                            className="select-group"
                            classNamePrefix="react-select"
                            placeholder="Paciente"
                            options={clienteData?.pacientes || []}
                            value={pacientesProductosData[index]}
                            isClearable={true}
                            onChange={(value) => handleSelectPacienteProducto(value, index)}
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            components={{
                                ValueContainer: CustomValueContainer
                            }}
                            styles={{ ...styles_select }}
                        />
                    </div>
                )
            }
        },
        {
            name: 'Precio base',
            cell: row => formatNumber(row.precio_actual / (row.conversion || 1), 2, '$ ', '')
        },
        {
            name: 'Precio manual',
            cell: (row, index) => {
                return(
                    <CurrencyInput
                        className="form-control text-center"
                        value={ventaData.productos[index]?.precio_manual || ''}
                        decimalsLimit={2}
                        groupSeparator=","
                        decimalSeparator="."
                        onValueChange={(value) => handlePrecioManualChange(value, index)}
                    />
                )
            }
        },
        {
            name: 'Precio final',
            cell: (row, index) => formatNumber(Math.ceil(ventaData.productos[index]?.precio_manual || 0), 0, '$ ', '')
        },
        /* {
            name: 'Inventario',
            cell: row => formatNumber(row.inventario * row.conversion, 0, '', '')
        }, */
        {
            name: 'Cantidad',
            cell: (row, index) => {
                if(row.comanda){
                    return formatNumber(ventaData.productos[index]?.cantidad, 2, '', '')
                }else{
                    return(
                        <input type="number" className="form-control" value={ventaData.productos[index]?.cantidad} onChange={e => handleCantidadChange(e, index)}/>
                    )
                }
            }
        }, 
        {
            name: 'Unidad',
            grow: 1.5,
            cell: (row, index) => {
                if(row.comanda){
                    return ventaData.productos[index]?.nombre_unidad || 'Sin definir'
                }else{
                    return(
                        <div className="input-group h-100 py-2">
                            <Select
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Venta"
                                options={row.unidades}
                                value={unidadesData[index]}
                                isClearable={true}
                                onChange={(value) => handleSelectUnidad(value, index)}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                components={{
                                    ValueContainer: CustomValueContainer
                                }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    )
                }
            }
        }, 
        {
            name: '',
            cell: (row, index) => {
                return(
                    <div className="text-right w-100">
                        <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleRemoveProducto(index)}><i className="fas fa-trash text-danger"></i></button>
                    </div>
                )
            }
        }
    ];

    const columnsServicios = [
        {
            name: 'Servicio',
            cell: row => row.nombre,
            grow: 5
        },
        {
            name: 'Paciente',
            grow: 1.5,
            cell: (row, index) => {
                return(
                    <div className="input-group h-100 py-2">
                        <Select
                            className="select-group"
                            classNamePrefix="react-select"
                            placeholder="Paciente"
                            options={clienteData?.pacientes || []}
                            value={pacientesData[index]}
                            isClearable={true}
                            onChange={(value) => handleSelectPaciente(value, index)}
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                            components={{
                                ValueContainer: CustomValueContainer
                            }}
                            styles={{ ...styles_select }}
                        />
                    </div>
                )
            }
        }, 
        {
            name: 'Precio base',
            cell: row => formatNumber(row.precio_actual, 2, '$ ', '')
        }, 
        {
            name: 'Precio final',
            cell: (row, index) => {
                if(row.comanda){
                    return formatNumber(ventaData.servicios[index]?.precio, 2, '$ ', '')
                }else{
                    return(
                        <CurrencyInput
                            className="form-control text-center"
                            value={ventaData.servicios[index]?.precio || ''}
                            decimalsLimit={2}
                            groupSeparator=","
                            decimalSeparator="."
                            onValueChange={(value) => handlePrecioServicioChange(value, index)}
                        />
                    )
                }

            }
        },
        {
            name: 'Cantidad',
            cell: (row, index) => {
                if(row.comanda){
                    return formatNumber(ventaData.servicios[index]?.cantidad || 1, 0, '', '')
                }else{
                    return(
                        <input type="number" step="1" className="form-control" value={ventaData.servicios[index]?.cantidad} onChange={e => handleCantidadServicioChange(e, index)}/>
                    )
                }
            }
        },
        {
            name: '',
            cell: (row, index) => {
                return(
                    <div className="text-right w-100">
                        <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleRemoveServicio(index)}><i className="fas fa-trash text-danger"></i></button>
                    </div>
                )
            }
        }
    ];

    const columnsComandas = [
        {
            name: 'Médico',
            grow: 1.5,
            cell: row => row.medico
        },
        {
            name: 'Evento',
            grow: 1.5,
            cell: row => row.evento
        },
        {
            name: 'Paciente',
            grow: 1,
            cell: row => row.paciente
        },
        {
            name: 'Productos',
            selector: row => row.productos
        },
        {
            name: 'Servicios',
            selector: row => row.servicios
        },
        {
            name: 'Fecha',
            grow: 1.5,
            cell: item => item.fecha && item.fecha != '0000-00-00' ? new Date(item.fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) + ' ' + new Date(item.fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }) : 'Sin definir'
        },
        {
            name: '',
            cell: (row, index) => {
                return(
                    <div className="text-right w-100">
                        <button type="button" className="btn btn-sm btn-link px-2 float-end" onClick={() => handleRemoveComanda(index)}><i className="fas fa-trash text-danger"></i></button>
                    </div>
                )
            }
        }
    ];

    let styles_select = {
        menuPortal: base => ({ ...base, zIndex: 9999 }), 
        container: (provided, state) => ({
            ...provided
        }),
        valueContainer: (provided, state) => ({
            ...provided,
            overflow: "visible", 
            marginTop: "15px"
        }),
        placeholder: (provided, state) => ({
            ...provided,
            position: "absolute",
            top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
            transition: "top 0.1s, font-size 0.1s",
            fontSize: (state.hasValue || state.selectProps.inputValue) && 13
        })
    };

    const handleInputChange = ({ target }) => {
        setVentaData({
            ...ventaData,
            [target.name]: target.value
        });
    }

    //Clientes
    const handleBuscarClientes = () => {
        if(!buscadorClientes){
            dispatch(buscarClientesPacientes({
                nombre: ventaData.busqueda_cliente
            }));
        }else{
            setVentaData({
                ...ventaData,
                id_cliente: null, 
                busqueda_cliente: null
            });
    
            setClienteData(null);
        }

        setBuscadorClientes(!buscadorClientes);
    }

    const handleSelectCliente = (option) => {
        setVentaData({
            ...ventaData,
            id_cliente: option ? option.value : null,
            servicios: option ? ventaData.servicios : ventaData.servicios.map(servicio => ({
                ...servicio,
                id_paciente: null
            })),
            productos: option ? ventaData.productos : ventaData.productos.map(producto => ({
                ...producto,
                id_paciente: null
            }))
        });

        setClienteData(option);

        if (!option) {
            setPacientesData(ventaData.servicios.map(() => null));
            setPacientesProductosData(ventaData.productos.map(() => null));
        }
    }

    //Médico
    const handleSelectMedico = (option) => {
        let medicos = [];

        for (var i = 0; i < option?.length; i++) {
            medicos.push(option[i].value);
        }

        setVentaData({
            ...ventaData,
            medicos
        });

        setMedicoData(option);
    }

    const handleSelectMedicoExterno = (option) => {
        let medicos_externos = [];

        for (var i = 0; i < option?.length; i++) {
            medicos_externos.push(option[i].value);
        }

        setVentaData({
            ...ventaData,
            medicos_externos
        });

        setMedicoExternoData(option);
    }

    //Productos
    const handleBuscarProductos = () => {
        if(!buscadorProductos){
            dispatch(buscarProductos({
                nombre: ventaData.busqueda_producto, 
                codigo_barras: null
            }));
        }else{
            setVentaData({
                ...ventaData,
                busqueda_producto: null
            });
        }

        setBuscadorProductos(!buscadorProductos);
    }

    const handleBuscarCodigo = ({ target }) => {
        dispatch(buscarProductos({
            nombre: null, 
            codigo_barras: target.value
        }));

        setVentaData({
            ...ventaData,
            busqueda_producto: null
        });

        target.value = '';

        setBuscadorProductos(true);
    }

    const handleSelectProducto = (option) => {
        let productos = ventaData.productos;
        let unidades = unidadesData;
        let pacientesProductos = pacientesProductosData;

        if(option){
            let producto_existente = productos.some(producto =>
                producto.id_producto == option.value &&
                producto.id_area == option.area &&
                producto.id_organizador == option.organizador &&
                producto.id_ubicacion == option.ubicacion
            );

            if(!producto_existente){
                if(option.inventario){
                    productos.push({
                        id_producto: option.value,
                        id_area: option.area,
                        id_organizador: option.organizador,
                        id_ubicacion: option.ubicacion,
                        id_unidad: null,
                        id_paciente: null,
                        nombre: option.nombre_corto,
                        inventario: option.inventario,
                        precio_actual: option.precio,
                        precio_manual: option.precio,
                        precio: Math.ceil(option.precio || 0),
                        conversion: 1,
                        cantidad: 0,
                        unidades: option.unidades,
                        comanda: false
                    });

                    unidades.push(null);
                    pacientesProductos.push(null);
                }else{
                    dispatch(setAlert('No puedes agregar productos sin existencias', 'danger'));
                }
            }else{
                dispatch(setAlert('Ya esta agregado este producto a la venta', 'danger'));
            }
        }

        setVentaData({
            ...ventaData,
            productos
        });

        setUnidadesData(unidades);
        setPacientesProductosData(pacientesProductos);

        setProductoData(null);
    }

    const handlePrecioManualChange = (value, posicion) => {
        let productos = ventaData.productos;
        let servicios = ventaData.servicios;
        let total = 0;
        let total_productos = 0;

        if(value >= 0){
            productos[posicion].precio_manual = value || '';
            productos[posicion].precio = Math.ceil(parseFloat(value) || 0);

            for (var i = 0; i < productos.length; i++) {
                total += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
                total_productos += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
            }

            for (var i = 0; i < servicios.length; i++) {
                total += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
            }

            setVentaData({
                ...ventaData,
                productos,
                total,
                total_productos
            });
        }else{
            dispatch(setAlert('No puedes vender montos negativos', 'danger'));
        }
    }

    const handleCantidadChange = ({ target }, posicion) => {
        let productos = ventaData.productos;
        let servicios = ventaData.servicios;
        let total = 0;
        let total_productos = 0;

        let inventario_convertido = productos[posicion].inventario * productos[posicion].conversion;
        
        if(target.value <= inventario_convertido){
            if(target.value >= 0){
                productos[posicion].cantidad = target.value || '';

                for (var i = 0; i < productos.length; i++) {
                    total += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
                    total_productos += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
                }

                for (var i = 0; i < servicios.length; i++) {
                    total += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
                }

                setVentaData({
                    ...ventaData,
                    productos,
                    total,
                    total_productos
                });
            }else{
                dispatch(setAlert('No puedes vender cantidades negativas', 'danger'));
            }
        }else{
            dispatch(setAlert('La cantidad excede la de inventario', 'danger'));
        }
    }

    const handleSelectUnidad = (option, posicion) => {
        let productos = ventaData.productos;
        let servicios = ventaData.servicios;
        let unidades = unidadesData;
        let total = 0;
        let total_productos = 0;

        let inventario_convertido = productos[posicion].inventario * (option ? option.cantidad : 1);

        if(productos[posicion].cantidad <= inventario_convertido){
            unidades[posicion] = option;

            const nuevaConversion = option ? option.cantidad : 1;
            productos[posicion].id_unidad = option ? option.value : null;
            productos[posicion].conversion = nuevaConversion;
            productos[posicion].precio_manual = productos[posicion].precio_actual / nuevaConversion;
            productos[posicion].precio = Math.ceil(productos[posicion].precio_actual / nuevaConversion);

            for (var i = 0; i < productos.length; i++) {
                total += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
                total_productos += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
            }

            for (var i = 0; i < servicios.length; i++) {
                total += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
            }

            setUnidadesData(unidades);

            setVentaData({
                ...ventaData,
                productos,
                total,
                total_productos
            });
        }else{
            dispatch(setAlert('La cantidad excede la de inventario', 'danger'));
        }
    }

    const handleSelectPacienteProducto = (option, posicion) => {
        let productos = ventaData.productos;
        let pacientesProductos = pacientesProductosData;

        pacientesProductos[posicion] = option;

        productos[posicion].id_paciente = option ? option.value : null;

        setPacientesProductosData(pacientesProductos);

        setVentaData({
            ...ventaData,
            productos
        });
    }

    const handleRemoveProducto = (posicion) => {
        let productos = ventaData.productos;
        let servicios = ventaData.servicios;
        let unidades = unidadesData;
        let pacientesProductos = pacientesProductosData;
        let total = 0;
        let total_productos = 0;

        if(!productos[posicion].comanda){
            productos.splice(posicion, 1);
            unidades.splice(posicion, 1);
            pacientesProductos.splice(posicion, 1);

            for (var i = 0; i < productos.length; i++) {
                total += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
                total_productos += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
            }

            for (var i = 0; i < servicios.length; i++) {
                total += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
            }

            setVentaData({
                ...ventaData,
                productos,
                total,
                total_productos
            });

            setUnidadesData(unidades);
            setPacientesProductosData(pacientesProductos);
        }else{
            dispatch(setAlert('No puedes quitar un producto de comanda', 'danger'));
        }
    }

    //Servicios
    const handleBuscarServicios = () => {
        if(!buscadorServicios){
            dispatch(buscarServicios({
                nombre: ventaData.busqueda_servicio
            }));
        }else{
            setVentaData({
                ...ventaData,
                busqueda_servicio: null
            });
        }

        setBuscadorServicios(!buscadorServicios);
    }

    const handleSelectServicio = (option) => {
        let productos = ventaData.productos;
        let servicios = ventaData.servicios;
        let total = 0;
        let total_servicios = 0;

        if(option){
            servicios.push({
                id_servicio: option.value,
                nombre: option.label,
                precio_actual: option.precio,
                precio: option.precio,
                cantidad: 1,
                comanda: false
            });

            for (var i = 0; i < productos.length; i++) {
                total += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
            }

            for (var i = 0; i < servicios.length; i++) {
                total += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
                total_servicios += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
            }
        }

        setVentaData({
            ...ventaData,
            servicios,
            total,
            total_servicios
        });

        setServicioData(null);
    }

    const handleSelectPaciente = (option, posicion) => {
        let servicios = ventaData.servicios;
        let pacientes = pacientesData;

        pacientes[posicion] = option;

        servicios[posicion].id_paciente = option ? option.value : null;

        setPacientesData(pacientes);

        setVentaData({
            ...ventaData,
            servicios
        });
    }

    const handleCantidadServicioChange = ({ target }, posicion) => {
        let productos = ventaData.productos;
        let servicios = ventaData.servicios;
        let total = 0;
        let total_servicios = 0;

        if(target.value >= 0){
            servicios[posicion].cantidad = parseInt(target.value) || '';

            for (var i = 0; i < productos.length; i++) {
                total += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
            }

            for (var i = 0; i < servicios.length; i++) {
                total += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
                total_servicios += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
            }

            setVentaData({
                ...ventaData,
                servicios,
                total,
                total_servicios
            });
        }else{
            dispatch(setAlert('No puedes vender cantidades negativas', 'danger'));
        }
    }

    const handlePrecioServicioChange = (value, posicion) => {
        let productos = ventaData.productos;
        let servicios = ventaData.servicios;
        let total = 0;
        let total_servicios = 0;
        
        if(value >= 0){
            servicios[posicion].precio = value || '';

            for (var i = 0; i < productos.length; i++) {
                total += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
            }

            for (var i = 0; i < servicios.length; i++) {
                total += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
                total_servicios += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
            }

            setVentaData({
                ...ventaData,
                servicios,
                total,
                total_servicios
            });
        }else{
            dispatch(setAlert('No puedes vender montos negativos', 'danger'));
        }
    }

    const handleRemoveServicio = (posicion) => {
        let productos = ventaData.productos;
        let servicios = ventaData.servicios;
        let total = 0;
        let total_servicios = 0;

        if(!servicios[posicion].comanda){
            servicios.splice(posicion, 1);

            let pacientes = pacientesData;
            pacientes.splice(posicion, 1);
            setPacientesData([...pacientes]);

            for (var i = 0; i < productos.length; i++) {
                total += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
            }

            for (var i = 0; i < servicios.length; i++) {
                total += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
                total_servicios += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
            }

            setVentaData({
                ...ventaData,
                servicios,
                total,
                total_servicios
            });
        }else{
            dispatch(setAlert('No puedes quitar un servicio de comanda', 'danger'));
        }
    }

    //Paquetes
    const handleBuscarPaquetes = () => {
        if (!buscadorPaquetes) {
            dispatch(buscarPaquetesPunto({
                nombre: ventaData.busqueda_paquete
            }));
        } else {
            setVentaData({
                ...ventaData,
                busqueda_paquete: null
            });
        }

        setBuscadorPaquetes(!buscadorPaquetes);
    }

    const handleSelectPaquete = (option) => {
        if (!option) return;

        let productos = ventaData.productos;
        let servicios = ventaData.servicios;
        let unidades = unidadesData;
        let pacientesProductos = pacientesProductosData;
        let total = 0;
        let total_productos = 0;
        let total_servicios = 0;

        for (const item of option.productos || []) {
            const idx = productos.findIndex(p =>
                p.id_producto == item.id &&
                p.id_area == item.area &&
                p.id_organizador == item.organizador &&
                p.id_ubicacion == item.ubicacion
            );
            if (idx >= 0) {
                productos[idx].cantidad = parseFloat(productos[idx].cantidad || 0) + parseFloat(item.cantidad || 1);
            } else {
                productos.push({
                    id_producto: item.id,
                    id_area: item.area,
                    id_organizador: item.organizador,
                    id_ubicacion: item.ubicacion,
                    id_unidad: item.id_unidad || null,
                    id_paciente: null,
                    nombre: item.nombre || 'Sin definir',
                    inventario: item.inventario || 0,
                    precio_actual: 0,
                    precio_manual: 0,
                    precio: 0,
                    conversion: item.conversion || 1,
                    cantidad: item.cantidad || 1,
                    unidades: item.unidades || [],
                    comanda: false
                });
                unidades.push(item.unidades?.find(u => u.value == item.id_unidad) || null);
                pacientesProductos.push(null);
            }
        }

        const nuevasPacientes = (option.servicios || []).map(() => null);

        for (const item of option.servicios || []) {
            servicios.push({
                id_servicio: item.id,
                nombre: item.nombre || 'Sin definir',
                precio_actual: item.precio_venta || 0,
                precio: item.precio_venta || 0,
                cantidad: item.cantidad || 1,
                comanda: false
            });
        }

        for (var i = 0; i < productos.length; i++) {
            total += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
            total_productos += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
        }

        for (var i = 0; i < servicios.length; i++) {
            total += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
            total_servicios += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
        }

        setPacientesData(prev => [...prev, ...nuevasPacientes]);
        setUnidadesData([...unidades]);
        setPacientesProductosData([...pacientesProductos]);
        setVentaData({ ...ventaData, productos, servicios, total, total_productos, total_servicios });
        setPaqueteData(null);
    }

    //Comandas
    const handleSelectComanda = (option) => {
        let medicos = ventaData.medicos;
        let medicos_externos = ventaData.medicos_externos;
        let productos = ventaData.productos;
        let servicios = ventaData.servicios;
        let comandas = ventaData.comandas;
        let total = 0;
        let total_productos = 0;
        let total_servicios = 0;

        if(option){
            let comanda_existente = comandas.some(comanda => 
                comanda.id_comanda == option.value
            );

            if(!comanda_existente){
                let cliente_elegido = ventaData.id_cliente;

                if(!clienteData && option.evento?.paciente?.cliente?.id){
                    const pacientes = (option.evento.paciente.pacientes || []).map(p => ({ value: p.id, label: p.nombre }));
                    const nombresPacientes = pacientes.length ? pacientes.map(p => p.label).join(', ') : option.evento.paciente.nombre;
                    const clienteOption = {
                        value: option.evento.paciente.cliente.id,
                        label: option.evento.paciente.cliente.nombre + ' ' + option.evento.paciente.cliente.apellido + ' (' + nombresPacientes + ')',
                        pacientes
                    };

                    setBuscadorClientes(!buscadorClientes);

                    setClientesFilter([clienteOption]);
                    setClienteData(clienteOption);

                    cliente_elegido = clienteOption.value;
                }

                //Seleccionar comanda
                comandas.push({
                    id_comanda: option.value,
                    medico: option.usuario?.id ? option.usuario?.nombre + ' ' + option.usuario?.apellido : 'Sin definir',
                    evento: option.evento?.tipo_evento?.nombre || 'Sin definir',
                    paciente: option.evento?.paciente?.nombre || 'Sin definir',
                    productos: option.productos?.length || 0,
                    servicios: option.servicios?.length || 0,
                    fecha: option.fecha
                });

                //Seleccionar médico
                if(option.usuario?.id){
                    if(!medicos.includes(option.usuario.id)){
                        medicos.push(option.usuario.id);
                    }

                    const medicoYaEnSelect = (medicoData || []).some(m => m.value === option.usuario.id);
                    if(!medicoYaEnSelect){
                        setMedicoData([...(medicoData || []), { value: option.usuario.id, label: option.usuario.nombre + ' ' + option.usuario.apellido }]);
                    }
                }

                //Seleccionar médico externo
                if(option.medico_externo?.id){
                    if(!medicos_externos.includes(option.medico_externo.id)){
                        medicos_externos.push(option.medico_externo.id);
                        setMedicoExternoData([...(medicoExternoData || []), { value: option.medico_externo.id, label: option.medico_externo.nombre }]);
                    }
                }

                const pacienteComanda = option.evento?.paciente?.id
                    ? { value: option.evento.paciente.id, label: option.evento.paciente.nombre }
                    : null;

                //Seleccionar productos
                for (var i = 0; i < option.productos?.length; i++) {
                    productos.push({
                        id_producto: option.productos[i].id,
                        id_area: option.productos[i].id_area,
                        id_organizador: option.productos[i].id_organizador,
                        id_ubicacion: option.productos[i].id_ubicacion,
                        id_unidad: option.productos[i].unidad?.id || null,
                        id_paciente: option.evento?.paciente?.id || null,
                        nombre_unidad: option.productos[i].unidad?.nombre || 'Sin definir',
                        nombre: option.productos[i].nombre + ' (Entregado)',
                        inventario: option.productos[i].inventario,
                        precio_actual: 0,
                        precio_manual: 0,
                        precio: 0,
                        conversion: option.productos[i].conversion,
                        cantidad: option.productos[i].cantidad,
                        unidades: [],
                        comanda: option.value
                    });
                }

                if (option.productos?.length) {
                    setPacientesProductosData(prev => [...prev, ...option.productos.map(() => pacienteComanda)]);
                }

                for (var i = 0; i < productos.length; i++) {
                    total += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
                    total_productos += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
                }

                //Seleccionar servicios
                for (var i = 0; i < option.servicios?.length; i++) {
                    servicios.push({
                        id_servicio: option.servicios[i].id,
                        nombre: option.servicios[i].nombre,
                        precio_actual: option.servicios[i].precio_actual,
                        precio: option.servicios[i].precio,
                        cantidad: option.servicios[i].cantidad || 1,
                        id_paciente: option.evento?.paciente?.id || null,
                        comanda: option.value
                    });
                }

                if (option.servicios?.length) {
                    setPacientesData([...pacientesData, ...option.servicios.map(() => pacienteComanda)]);
                }

                for (var i = 0; i < servicios.length; i++) {
                    total += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
                    total_servicios += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
                }

                setVentaData({
                    ...ventaData,
                    id_cliente: cliente_elegido,
                    medicos,
                    medicos_externos,
                    comandas,
                    productos,
                    servicios,
                    total,
                    total_productos,
                    total_servicios
                });
            }else{
                dispatch(setAlert('Esa comanda ya fue agregada', 'danger'));
            }
        }

        setComandaData(null);
    }

    const handleRemoveComanda = (posicion) => {
        let comandas = ventaData.comandas;
        let productos = ventaData.productos;
        let servicios = ventaData.servicios;
        let productos_finales = [];
        let servicios_finales = [];
        let total = 0;
        let total_productos = 0;
        let total_servicios = 0;

        let comanda_retirar = comandas[posicion];

        if(comanda_retirar){
            comandas.splice(posicion, 1);

            let pacientesProductos_finales = [];
            for (var i = 0; i < productos.length; i++) {
                if(!productos[i].comanda || productos[i].comanda !== comanda_retirar.id_comanda){
                    total += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);
                    total_productos += parseFloat(productos[i].cantidad || 0) * parseFloat(productos[i].precio || 0);

                    productos_finales.push(productos[i]);
                    pacientesProductos_finales.push(pacientesProductosData[i] || null);
                }
            }

            let pacientes_finales = [];
            for (var i = 0; i < servicios.length; i++) {
                if(!servicios[i].comanda || servicios[i].comanda !== comanda_retirar.id_comanda){
                    total += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);
                    total_servicios += parseFloat(servicios[i].cantidad || 1) * parseFloat(servicios[i].precio || 0);

                    servicios_finales.push(servicios[i]);
                    pacientes_finales.push(pacientesData[i] || null);
                }
            }

            setPacientesData(pacientes_finales);
            setPacientesProductosData(pacientesProductos_finales);

            setVentaData({
                ...ventaData,
                comandas,
                productos: productos_finales,
                servicios: servicios_finales,
                total,
                total_productos,
                total_servicios
            });
        }else{
            dispatch(setAlert('No es posible retirar la comanda', 'danger'));
        }
    }

    //Metodos
    const agregarMetodo = () => {
        let nuevoMetodo = { id_metodo: null, tipo: 1, total: 0 };

        if (metodosPago.length == 0) {
            nuevoMetodo.total = ventaData.total;
        }

        setMetodosPago([...metodosPago, nuevoMetodo]);
    };

    const eliminarMetodo = (index) => {
        const copia = [...metodosPago];
        copia.splice(index, 1);

        if (copia.length == 1) {
            copia[0].total = ventaData.total;
        }

        setMetodosPago(copia);
    };

    const actualizarMetodo = (index, campo, valor) => {
        const copia = [...metodosPago];
        copia[index][campo] = valor;
        setMetodosPago(copia);
    }

    const validarMetodos = () => {
        if (metodosPago.length == 0) return false;

        const todosValidos = metodosPago.every(
            m => m.id_metodo && Number(m.total) > 0
        );

        if (!todosValidos) return false;

        if (Number(totalMetodos.toFixed(2)) !== Number(ventaData.total.toFixed(2))) {
            return false;
        }

        if (Number(totalProductosMetodos.toFixed(2)) !== Number(ventaData.total_productos.toFixed(2))) {
            return false;
        }

        if (Number(totalServiciosMetodos.toFixed(2)) !== Number(ventaData.total_servicios.toFixed(2))) {
            return false;
        }

        return true;
    }

    //Vender
    const handleImprimirVenta = () => {
        printTicket(ventaRealizadaData);
    }

    /* const handleTicketUsb = async () => {
        const venta = {
            id: 123,
            total: 150,
            items: [
              { nombre: "Coca Cola", cantidad: 2, total: 50 },
              { nombre: "Sabritas", cantidad: 1, total: 100 },
            ]
        };

        const buffer = await renderToBuffer(<Ticket venta={venta} />);
      
        const device = await navigator.usb.requestDevice({
          filters: [{ vendorId: 0x04b8 }],
        });
      
        await device.open();
        await device.selectConfiguration(1);
        await device.claimInterface(0);
        await device.transferOut(1, buffer);
    } */

    /* const handleTicketUsb = async () => {
        try {
            const venta = {
                id: 123,
                total: 150,
                items: [
                  { nombre: "Coca Cola", cantidad: 2, total: 50 },
                  { nombre: "Sabritas", cantidad: 1, total: 100 },
                ]
            };
            
            const encoder = new EscPosEncoder();
            const result = encoder
              .initialize()
              .align('center')
              .bold(true)
              .line('MI TIENDA')
              .bold(false)
              .newline()
              .align('left')
              .line(`Venta #${venta.id}`)
              .newline();
        
            venta.items.forEach(item => {
              result.line(`${item.nombre} x${item.cantidad} $${item.total.toFixed(2)}`);
            });
        
            result
              .newline()
              .bold(true)
              .line(`TOTAL: $${venta.total.toFixed(2)}`)
              .bold(false)
              .newline()
              .align('center')
              .line('¡Gracias por su compra!')
              .cut();
        
            const buffer = result.encode();
        
            console.log('Solicitando dispositivo USB...');
            const device = await navigator.usb.requestDevice({
              filters: [{ vendorId: 0x04b8 }], // Epson vendor ID
            });
        
            if (!device) {
              alert('No se seleccionó ningún dispositivo');
              return;
            }
        
            console.log('Dispositivo seleccionado:', device.productName);
            await device.open();
            console.log('Dispositivo abierto');
        
            await device.selectConfiguration(1);
            console.log('Configuración seleccionada');
        
            await device.claimInterface(0);
            console.log('Interfaz reclamada');
        
            await device.transferOut(1, buffer);
            console.log('Datos enviados a la impresora');
          } catch (error) {
            console.error('Error imprimiendo:', error);
            alert('No se pudo imprimir: ' + error.message);
          }
    } */

    const handleVender = async (status) => {
        const tieneProductos = ventaData.productos.length > 0;
        const tieneServicios = ventaData.servicios.length > 0;

        if (!tieneProductos && !tieneServicios && status == 0) {
            await dispatch(setAlert('Debe de haber al menos un producto o servicio', 'danger'));
            return;
        }

        if (status == 0 && !validarMetodos()) {
            await dispatch(setAlert('Los métodos de pago deben sumar exactamente el total', 'danger'));
            return;
        }
        
        await setStatusProcesar(true);
        await dispatch(crearVenta({
            ...ventaData,
            productos: ventaData.productos.map(p => ({
                ...p,
                precio_manual: parseFloat(p.precio_manual || 0) * (p.conversion || 1),
                precio: parseFloat(p.precio || 0) * (p.conversion || 1)
            })),
            metodos: metodosPago
            .filter(m => m.id_metodo)
            .map(m => ({
                id_metodo: m.id_metodo,
                total: Number(m.total),
                tipo: m.tipo ?? 0
            })),
            status
        }));
        await handleCancelar(false);
        await setStatusProcesar(false);
    }

    const handleCancelar = async (ticket) => {
        setVentaData({
            id_cliente: null,
            total: 0,
            total_productos: 0,
            total_servicios: 0,
            busqueda_cliente: null,
            busqueda_producto: null,
            busqueda_servicio: null,
            productos: [],
            servicios: [],
            comandas: [],
            medicos: [],
            medicos_externos: [],
            observaciones: ''
        });

        setMetodosPago([{ id_metodo: null, total: 0 }]);
        setUnidadesData([]);
        setPacientesData([]);
        setPacientesProductosData([]);
        setClienteData(null);
        setMedicoData(null);
        setMedicoExternoData(null);
        setComandaData(null);

        setClientesFilter([]);
        setProductosFilter([]);
        setServiciosFilter([]);

        setBuscadorClientes(false);
        setBuscadorProductos(false);
        setBuscadorServicios(false);
        setBuscadorPaquetes(false);
        setPaqueteData(null);

        dispatch(buscarComandas({ id_venta: null }));
        
        if(ticket){
            dispatch(limpiarVenta());
        }
    }

    useEffect(() => {
        dispatch(buscarComandas({ id_venta: null }));
        dispatch(buscarMedicos());
        dispatch(buscarMedicosExternos());
        dispatch(filtrarMetodosConfiguracion(4));
    }, []);

    useEffect(() => {
        if (metodosPago.length == 1) {
            const copia = [...metodosPago];
            copia[0].total = ventaData.total;
            setMetodosPago(copia);
        }
    }, [ventaData.total]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_metodos.length; i++) {
            options.push({ value: listado_metodos[i].id, label: listado_metodos[i].nombre });
        }

        setMetodosFilter(options);
    }, [listado_metodos]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_clientes.length; i++) {
            const nombresPacientes = listado_clientes[i].pacientes?.length
                ? listado_clientes[i].pacientes.map(p => p.nombre).join(', ')
                : 'Sin pacientes';

            let pacientes = [];

            for (var x = 0; x < listado_clientes[i].pacientes?.length; x++) {
                pacientes.push({ value: listado_clientes[i].pacientes[x]?.id, label: listado_clientes[i].pacientes[x]?.nombre });
            }

            options.push({ value: listado_clientes[i].cliente?.id, label: listado_clientes[i].cliente?.nombre + ' (' + nombresPacientes + ')', pacientes: pacientes });
        }

        setClientesFilter(options);
    }, [listado_clientes]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_productos.length; i++) {
            options.push({ value: listado_productos[i].id, label: listado_productos[i].nombre, nombre_corto: listado_productos[i].nombre_corto, area: listado_productos[i].area, organizador: listado_productos[i].organizador, ubicacion: listado_productos[i].ubicacion, inventario: listado_productos[i].inventario, precio: listado_productos[i].precio, unidades: listado_productos[i].unidades });
        }

        setProductosFilter(options);
    }, [listado_productos]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_servicios.length; i++) {
            options.push({ value: listado_servicios[i].id, label: listado_servicios[i].nombre, categoria: listado_servicios[i].categoria, subcategoria: listado_servicios[i].subcategoria, subsubcategoria: listado_servicios[i].subsubcategoria, precio: listado_servicios[i].precio_venta });
        }

        setServiciosFilter(options);
    }, [listado_servicios]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_comandas.length; i++) {
            options.push({
                value: listado_comandas[i].id,
                label: listado_comandas[i].evento?.tipo_evento?.nombre + ' (' + listado_comandas[i].evento?.paciente?.nombre + ' - ' + listado_comandas[i].usuario?.nombre + ' ' + listado_comandas[i].usuario?.apellido + ') el ' + new Date(listado_comandas[i].fecha).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }) + ' ' + new Date(listado_comandas[i].fecha).toLocaleTimeString('es-MX', { hour: '2-digit', minute: '2-digit' }),
                evento: listado_comandas[i].evento,
                fecha: listado_comandas[i].fecha,
                usuario: listado_comandas[i].usuario,
                medico_externo: listado_comandas[i].medico_externo,
                productos: listado_comandas[i].productos,
                servicios: listado_comandas[i].servicios
            });
        }

        setComandasFilter(options);
    }, [listado_comandas]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_paquetes.length; i++) {
            options.push({ value: listado_paquetes[i].id, label: listado_paquetes[i].nombre, productos: listado_paquetes[i].productos, servicios: listado_paquetes[i].servicios });
        }

        setPaquetesFilter(options);
    }, [listado_paquetes]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_medicos.length; i++) {
            options.push({ value: listado_medicos[i].id, label: listado_medicos[i].nombre + ' ' + listado_medicos[i].apellido });
        }

        setMedicosFilter(options);
    }, [listado_medicos]);

    useEffect(() => {
        let options = [];

        for (var i = 0; i < listado_medicos_externos.length; i++) {
            options.push({ value: listado_medicos_externos[i].id, label: listado_medicos_externos[i].nombre });
        }

        setMedicosExternosFilter(options);
    }, [listado_medicos_externos]);

    useEffect(() => {
        if(detalles){
            if(detalles?.status == 0){
                setVentaRealizadaData({
                    ...ventaRealizadaData,
                    id: detalles?.id,
                    folio: detalles?.folio,
                    cliente: detalles?.cliente,
                    fecha: detalles?.fecha,
                    status: detalles?.status,
                    total: detalles?.total,
                    metodos: detalles?.metodos,
                    productos: detalles?.productos,
                    servicios: detalles?.servicios,
                    medicos: detalles?.medicos,
                    medicos_externos: detalles?.medicos_externos
                });
            }else{
                setVentaRealizadaData({
                    id: null,
                    folio: null,
                    cliente: null,
                    fecha: null,
                    status: 0,
                    total: 0,
                    metodos: [],
                    productos: [],
                    servicios: [],
                    medicos: [],
                    medicos_externos: []
                });
            }
        }else{
            setVentaRealizadaData({
                id: null,
                folio: null,
                cliente: null,
                fecha: null,
                status: 0,
                total: 0,
                metodos: [],
                productos: [],
                servicios: [],
                medicos: [],
                medicos_externos: []
            });
        }
    }, [detalles]);

    useEffect(() => {
        dispatch(editarBreadcrumb(rutasBread));
    }, [rutasBread]);

    let comandasFiltradas = comandasFilter;
    if (clienteData?.pacientes?.length) {
        const pacienteIds = clienteData.pacientes.map(p => p.value);
        comandasFiltradas = comandasFilter.filter(c => pacienteIds.includes(c.evento?.paciente?.id));
    } else if (ventaData.comandas.length > 0) {
        const selectedIds = ventaData.comandas.map(c => c.id_comanda);
        const selectedOpts = comandasFilter.filter(c => selectedIds.includes(c.value));
        const pacienteIds = [...new Set(selectedOpts.map(c => c.evento?.paciente?.id).filter(Boolean))];
        if (pacienteIds.length > 0) {
            comandasFiltradas = comandasFilter.filter(c => pacienteIds.includes(c.evento?.paciente?.id));
        }
    }

    return (
        <Fragment>
            <HelmetProvider>
                <Helmet>
                    <style>{`
                        html, body, #root {
                            height: 100%
                        }

                        #root{
                            display: flex !important;
                            flex-direction: column !important;
                        }

                        .container-fluid.principal-section{
                            flex-grow: 1;
                        }

                        .container-venta{
                            display: flex;    
                            flex-direction: column !important;
                            flex-grow: 1;
                        }

                        .select-group {
                            height: 100%;
                        }

                        .button-append {
                            padding: 0.39rem 0.70rem !important;
                            border-radius: 0 25% 25% 0 !important;
                            height: 100%;
                        }

                        .input_total {
                            border: 4px solid #caec67;
                        }
                    `}</style>
                </Helmet>
            </HelmetProvider>

            <div className="container-venta px-4 pb-4 h-100">
                <h3 className="my-3">Nueva venta</h3>

                <div className="buscadores row">
                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group h-100">
                            {
                                buscadorClientes &&
                                    <div className="form-floating h-100">
                                        <Select
                                            name="id_cliente"
                                            className="select-group"
                                            classNamePrefix="react-select"
                                            placeholder="Cliente"
                                            options={clientesFilter}
                                            value={clienteData}
                                            isClearable={true}
                                            onChange={(value) => handleSelectCliente(value)}
                                            menuPortalTarget={document.body}
                                            menuPlacement="auto"
                                            components={{
                                                ValueContainer: CustomValueContainer
                                            }}
                                            styles={{ ...styles_select }}
                                        />
                                    </div>
                            }

                            {
                                !buscadorClientes &&
                                    <div className="form-floating">
                                        <input id="busqueda_cliente" name="busqueda_cliente" type="text" className="form-control text-center" onChange={e => handleInputChange(e)} onKeyDown={e => { if (e.key === 'Enter') handleBuscarClientes(); }} />
                                        <label htmlFor="busqueda_cliente">Buscador de clientes</label>
                                    </div>
                            }

                            <div className="input-group-append">
                                <button className={'btn button-append btn-' + (buscadorClientes ? 'secondary' : 'primary')} onClick={() => handleBuscarClientes()}><i className={'fa-solid fa-' + (buscadorClientes ? 'xmark' : 'search')}></i></button>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="ids_medicos"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Médicos involucrados"
                                options={medicosFilter}
                                value={medicoData}
                                isClearable={true}
                                isMulti={true}
                                onChange={(value) => handleSelectMedico(value)}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                components={{
                                    ValueContainer: CustomValueContainer
                                }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>

                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="ids_medicos_externos"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Médicos externos"
                                options={medicosExternosFilter}
                                value={medicoExternoData}
                                isClearable={true}
                                isMulti={true}
                                onChange={(value) => handleSelectMedicoExterno(value)}
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                components={{
                                    ValueContainer: CustomValueContainer
                                }}
                                styles={{ ...styles_select }}
                            />
                        </div>
                    </div>
                </div>

                <div className="mt-3 flex-grow-1">
                    <ul className="nav nav-pills nav-fill">
                        <li className="nav-item">
                            <div className="input-group-append">
                                <button type="button" className={'nav-link border border-primary' + (seccionVenta == 0 ? ' text-black bg-primary' : '')} onClick={() => setSeccionVenta(0)}>Productos ({ventaData.productos.length})</button>
                            </div>
                        </li>
                        <li className="nav-item">
                            <div className="input-group-append">
                                <button type="button" className={'nav-link border border-primary' + (seccionVenta == 1 ? ' text-black bg-primary' : '')} onClick={() => setSeccionVenta(1)}>Servicios ({ventaData.servicios.length})</button>
                            </div>
                        </li>
                        <li className="nav-item">
                            <div className="input-group-append">
                                <button type="button" className={'nav-link border border-primary' + (seccionVenta == 2 ? ' text-black bg-primary' : '')} onClick={() => setSeccionVenta(2)}>Comandas ({ventaData.comandas.length})</button>
                            </div>
                        </li>
                        <li className="nav-item">
                            <div className="input-group-append">
                                <button type="button" className={'nav-link border border-primary' + (seccionVenta == 3 ? ' text-black bg-primary' : '')} onClick={() => setSeccionVenta(3)}>Paquetes</button>
                            </div>
                        </li>
                        <li className="nav-item">
                            <div className="input-group-append">
                                <button type="button" className={'nav-link border border-primary' + (seccionVenta == 4 ? ' text-black bg-primary' : '')} onClick={() => setSeccionVenta(4)}>Observaciones</button>
                            </div>
                        </li>
                    </ul>
                    
                    {
                        seccionVenta == 0 &&
                            <div className="productos row mt-3">
                                <div className="col-md-3 form-group mb-3">
                                    <div className="input-group">
                                        <div className="form-floating">
                                            <input id="codigo_barras" name="codigo_barras" type="text" className="form-control text-center" onKeyDown={(e) => {if (e.key == "Enter") { handleBuscarCodigo(e); }}} />
                                            <label htmlFor="codigo_barras">Código de barras</label>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-9 form-group mb-3">
                                    <div className="input-group">
                                        {
                                            buscadorProductos && 
                                                <div className="form-floating h-100">
                                                    <Select
                                                        name="id_producto"
                                                        className="select-group"
                                                        classNamePrefix="react-select"
                                                        placeholder="Productos"
                                                        options={productosFilter}
                                                        value={productoData}
                                                        isClearable={true}
                                                        onChange={(value) => handleSelectProducto(value)}
                                                        menuPortalTarget={document.body}
                                                        menuPlacement="auto"
                                                        components={{
                                                            ValueContainer: CustomValueContainer
                                                        }}
                                                        styles={{ ...styles_select }}
                                                    />
                                                </div>
                                        }

                                        {
                                            !buscadorProductos && 
                                                <div className="form-floating">
                                                    <input id="busqueda_producto" name="busqueda_producto" type="text" className="form-control text-center" onChange={e => handleInputChange(e)} onKeyDown={e => { if (e.key === 'Enter') handleBuscarProductos(); }} />
                                                    <label htmlFor="busqueda_producto">Buscador de productos</label>
                                                </div>
                                        }

                                        <div className="input-group-append">
                                            <button className={'btn button-append btn-' + (buscadorProductos ? 'secondary' : 'primary')} onClick={() => handleBuscarProductos()}><i className={'fa-solid fa-' + (buscadorProductos ? 'xmark' : 'search')}></i></button>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-md-12 form-group mb-3">
                                    <DataTable 
                                        columns={columnsProductos}
                                        data={ventaData.productos}
                                        highlightOnHover={true}
                                    />
                                </div>
                            </div>
                    }

                    {
                        seccionVenta == 1 &&
                            <div className="servicios row mt-3">
                                <div className="col-md-12 form-group mb-3">
                                    <div className="input-group">
                                        {
                                            buscadorServicios && 
                                                <div className="form-floating h-100">
                                                    <Select
                                                        name="id_servicio"
                                                        className="select-group"
                                                        classNamePrefix="react-select"
                                                        placeholder="Servicios"
                                                        options={serviciosFilter}
                                                        value={servicioData}
                                                        isClearable={true}
                                                        onChange={(value) => handleSelectServicio(value)}
                                                        menuPortalTarget={document.body}
                                                        menuPlacement="auto"
                                                        components={{
                                                            ValueContainer: CustomValueContainer
                                                        }}
                                                        styles={{ ...styles_select }}
                                                    />
                                                </div>
                                        }

                                        {
                                            !buscadorServicios && 
                                                <div className="form-floating">
                                                    <input id="busqueda_servicio" name="busqueda_servicio" type="text" className="form-control text-center" onChange={e => handleInputChange(e)} onKeyDown={e => { if (e.key === 'Enter') handleBuscarServicios(); }} />
                                                    <label htmlFor="busqueda_servicio">Buscador de servicios</label>
                                                </div>
                                        }

                                        <div className="input-group-append">
                                            <button className={'btn button-append btn-' + (buscadorServicios ? 'secondary' : 'primary')} onClick={() => handleBuscarServicios()}><i className={'fa-solid fa-' + (buscadorServicios ? 'xmark' : 'search')}></i></button>
                                        </div>
                                    </div>
                                </div>
                                
                                <div className="col-md-12 form-group mb-3">
                                    <DataTable 
                                        columns={columnsServicios}
                                        data={ventaData.servicios}
                                        highlightOnHover={true}
                                    />
                                </div>
                            </div>
                    }

                    {
                        seccionVenta == 2 &&
                            <div className="comandas row mt-3">
                                <div className="col-md-12 form-group mb-3">
                                    <div className="form-floating h-100">
                                        <Select
                                            name="id_comanda"
                                            className="select-group"
                                            classNamePrefix="react-select"
                                            placeholder="Comandas"
                                            options={comandasFiltradas}
                                            value={comandaData}
                                            isClearable={true}
                                            onChange={(value) => handleSelectComanda(value)}
                                            menuPortalTarget={document.body}
                                            menuPlacement="auto"
                                            components={{
                                                ValueContainer: CustomValueContainer
                                            }}
                                            styles={{ ...styles_select }}
                                        />
                                    </div>
                                </div>
                                
                                <div className="col-md-12 form-group mb-3">
                                    <DataTable 
                                        columns={columnsComandas}
                                        data={ventaData.comandas}
                                        highlightOnHover={true}
                                    />
                                </div>
                            </div>
                    }

                    {
                        seccionVenta == 3 &&
                            <div className="paquetes row mt-3">
                                <div className="col-md-12 form-group mb-3">
                                    <div className="input-group">
                                        {
                                            buscadorPaquetes &&
                                                <div className="form-floating h-100">
                                                    <Select
                                                        name="id_paquete"
                                                        className="select-group"
                                                        classNamePrefix="react-select"
                                                        placeholder="Paquetes"
                                                        options={paquetesFilter}
                                                        value={paqueteData}
                                                        isClearable={true}
                                                        onChange={(value) => handleSelectPaquete(value)}
                                                        menuPortalTarget={document.body}
                                                        menuPlacement="auto"
                                                        components={{
                                                            ValueContainer: CustomValueContainer
                                                        }}
                                                        styles={{ ...styles_select }}
                                                    />
                                                </div>
                                        }

                                        {
                                            !buscadorPaquetes &&
                                                <div className="form-floating">
                                                    <input id="busqueda_paquete" name="busqueda_paquete" type="text" className="form-control text-center" onChange={e => handleInputChange(e)} onKeyDown={e => { if (e.key === 'Enter') handleBuscarPaquetes(); }} />
                                                    <label htmlFor="busqueda_paquete">Buscador de paquetes</label>
                                                </div>
                                        }

                                        <div className="input-group-append">
                                            <button className={'btn button-append btn-' + (buscadorPaquetes ? 'secondary' : 'primary')} onClick={() => handleBuscarPaquetes()}><i className={'fa-solid fa-' + (buscadorPaquetes ? 'xmark' : 'search')}></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }

                    {
                        seccionVenta == 4 &&
                            <div className="observaciones row mt-3">
                                <div className="col-md-12 form-group mb-3">
                                    <div className="input-group">
                                        <div className="form-floating">
                                            <textarea className="form-control textareCampo" placeholder="Observaciones" id="observaciones" name="observaciones" value={ventaData.observaciones} onChange={e => handleInputChange(e)}></textarea>
                                            <label htmlFor="observaciones">Observaciones</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                    }
                </div>

                <div className="botones row">
                    <div className="col-md-3 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input id="total" name="total" type="text" className="form-control text-center input_total" value={formatNumber(ventaData.total, 2, '$ ', '')} disabled />
                                <label htmlFor="total">Total a pagar</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-2 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input id="total_productos" name="total_productos" type="text" className="form-control text-center" value={formatNumber(ventaData.total_productos, 2, '$ ', '')} disabled />
                                <label htmlFor="total_productos">Total productos</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-2 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input id="total_servicios" name="total_servicios" type="text" className="form-control text-center" value={formatNumber(ventaData.total_servicios, 2, '$ ', '')} disabled />
                                <label htmlFor="total_servicios">Total servicios</label>
                            </div>
                        </div>
                    </div>
                    
                    <div className="col-md form-group mb-3">
                        <button type="button" className={"btn w-100 h-100 btn-" + (ventaRealizadaData.id ? 'info' : 'secondary')} onClick={handleImprimirVenta} disabled={ statusProcesar || !ventaRealizadaData.id }>Ticket</button>
                    </div>

                    <div className="col-md form-group mb-3">
                        <button 
                            type="button" 
                            className="btn btn-info w-100 h-100" 
                            onClick={() => {
                                setTipoVenta(2);
                                setModalMetodos(true);
                            }}
                            disabled={ statusProcesar }
                        >
                            Pausar
                        </button>
                    </div>

                    <div className="col-md form-group mb-3">
                        <button
                            type="button" 
                            className="btn btn-success w-100 h-100" 
                            onClick={() => {
                                setTipoVenta(0);
                                setModalMetodos(true)
                            }} 
                            disabled={ statusProcesar }
                        >
                            Pagar
                        </button>
                    </div>

                    <div className="col-md form-group mb-3">
                        <button type="button" className="btn btn-danger w-100 h-100" onClick={() => {handleCancelar(true)}} disabled={ statusProcesar }>Limpiar</button>
                    </div>
                </div>
            </div>

            {modalMetodos && (
                <Modal 
                    show={modalMetodos} 
                    size="lg" 
                    backdrop="static" 
                    centered 
                    onHide={() => setModalMetodos(false)}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Métodos de pago</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <div className="row">

                            {metodosPago.map((m, index) => (
                                <div key={index} className="col-md-12 mb-3">
                                    <div className="row align-items-center">

                                        {/* MÉTODO */}
                                        <div className="col-md-4">
                                            <Select
                                                className="select-group"
                                                classNamePrefix="react-select"
                                                placeholder="Método de pago"
                                                options={metodosFilter}
                                                value={metodosFilter.find(x => x.value == m.id_metodo) || null}
                                                isClearable
                                                onChange={(option) =>
                                                    actualizarMetodo(index, 'id_metodo', option?.value)
                                                }
                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                components={{
                                                    ValueContainer: CustomValueContainer
                                                }}
                                                styles={{ ...styles_select }}
                                            />
                                        </div>

                                        {/* TIPO */}
                                        <div className="col-md-3">
                                            <Select
                                                className="select-group"
                                                classNamePrefix="react-select"
                                                placeholder="Tipo"
                                                options={tiposMetodoFilter}
                                                value={tiposMetodoFilter.find(x => x.value == m.tipo) || tiposMetodoFilter[0]}
                                                onChange={(option) =>
                                                    actualizarMetodo(index, 'tipo', option?.value ?? 0)
                                                }
                                                menuPortalTarget={document.body}
                                                menuPlacement="auto"
                                                components={{
                                                    ValueContainer: CustomValueContainer
                                                }}
                                                styles={{ ...styles_select }}
                                            />
                                        </div>

                                        {/* MONTO */}
                                        <div className="col-md-3">
                                            <div className="input-group">
                                                <div className="form-floating">
                                                    <CurrencyInput
                                                        className="form-control text-center"
                                                        value={m.total}
                                                        decimalsLimit={2}
                                                        groupSeparator=","
                                                        decimalSeparator="."
                                                        onValueChange={(value) =>
                                                            actualizarMetodo(index, 'total', value)
                                                        }
                                                    />
                                                    <label htmlFor="total">Monto</label>
                                                </div>
                                            </div>
                                        </div>

                                        {/* ELIMINAR */}
                                        <div className="col-md-2 text-center">
                                            {metodosPago.length > 1 && (
                                                <button
                                                    className="btn btn-link text-danger"
                                                    onClick={() => eliminarMetodo(index)}
                                                >
                                                    <i className="fas fa-trash"></i>
                                                </button>
                                            )}
                                        </div>

                                    </div>
                                </div>
                            ))}

                            {/* AGREGAR */}
                            <div className="col-md-12 mb-3">
                                <button 
                                    className="btn btn-outline-primary w-100" 
                                    onClick={agregarMetodo}
                                >
                                    + Agregar método
                                </button>
                            </div>

                            {/* RESUMEN */}
                            <div className="col-md-12">
                                <hr />
                                <table className="table table-sm text-end mb-0">
                                    <thead>
                                        <tr>
                                            <th className="text-start"></th>
                                            <th>Total</th>
                                            <th>Asignado</th>
                                            <th>Restante</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className="text-start">Productos</td>
                                            <td>{formatNumber(ventaData.total_productos, 2, '$ ', '')}</td>
                                            <td>{formatNumber(totalProductosMetodos, 2, '$ ', '')}</td>
                                            <td className={ventaData.total_productos - totalProductosMetodos == 0 ? 'text-success' : ''}>
                                                {formatNumber(ventaData.total_productos - totalProductosMetodos, 2, '$ ', '')}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td className="text-start">Servicios</td>
                                            <td>{formatNumber(ventaData.total_servicios, 2, '$ ', '')}</td>
                                            <td>{formatNumber(totalServiciosMetodos, 2, '$ ', '')}</td>
                                            <td className={ventaData.total_servicios - totalServiciosMetodos == 0 ? 'text-success' : ''}>
                                                {formatNumber(ventaData.total_servicios - totalServiciosMetodos, 2, '$ ', '')}
                                            </td>
                                        </tr>
                                        <tr className="fw-bold border-top">
                                            <td className="text-start">Total</td>
                                            <td>{formatNumber(ventaData.total, 2, '$ ', '')}</td>
                                            <td>{formatNumber(totalMetodos, 2, '$ ', '')}</td>
                                            <td className={restanteMetodos == 0 ? 'text-success' : 'text-danger'}>
                                                {formatNumber(restanteMetodos, 2, '$ ', '')}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button 
                            className="btn btn-secondary" 
                            onClick={() => setModalMetodos(false)}
                        >
                            Cancelar
                        </button>

                        <button
                            className="btn btn-success"
                            disabled={tipoVenta == 0 ? !validarMetodos() : false}
                            onClick={() => {
                                setModalMetodos(false);
                                handleVender(tipoVenta);
                            }}
                        >
                            {tipoVenta == 0 ? 'Confirmar pago' : 'Pausar venta'}
                        </button>
                    </Modal.Footer>
                </Modal>
            )}
        </Fragment>
    )
}

export default Punto;